export const ADDRESS_LINES = 'AddressLineFields';
export const CITY = 'CityField';
export const COUNTRY_SUBDIVISION = 'CountrySubdivisionSelect';
export const POSTAL_CODE = 'PostalCodeField';
